import { UseCaseName } from "@amzn/fuse-accounting-central-datastore-client";
import { STANDARD_USE_CASE_NAMES } from "src/components/constants/appConstants";

// e.g. 444552806502#AROAWPALJQBTOBBLABCA2:CognitoIdentityCredentials#zchenpds@amazon.com
export const getUserAlias = (changedBy: string | null | undefined) => {
  if (!changedBy) return null;
  const match = changedBy.match(/.*[#:]([a-z]{1,10})@/);
  return match ? match[1] : null;
};

export const getLocalTime = (dateString: string | null | undefined) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    timeZoneName: "short",
  });
};

export const SPLIT_PANEL_STICKY_HEADER_OFFSET = 60;

// Scroll margin to compensate for sticky headers when navigating to sections
export const ANCHOR_SCROLL_MARGIN_TOP = 80;

// Section ID constants for anchor navigation
export const SECTION_IDS = {
  DETAILS: "details-section",
  FUSE_PLANS: "fuse-plans-section",
  USE_CASES: "use-cases-section",
} as const;

// Helper function to get use case section ID
// Use name-based ID for known use case names, index-based for OTHER or unknown
export const getUseCaseSectionId = (
  name: UseCaseName | undefined,
  index: number,
) => {
  if (name && STANDARD_USE_CASE_NAMES.includes(name)) {
    return `use-case-${name.toLowerCase().replace(/_/g, "-")}`;
  }
  return `use-case-${index}`;
};

export const SCROLL_INTO_VIEW_OPTIONS = {
  container: "nearest",
  behavior: "smooth",
  block: "start",
} as ScrollIntoViewOptions;

// Colspan: the number of columns of each grid element ranges between 1 and 12
export const MARKDOWN_PAGE_GRID_DEFINITION = [
  {
    // TOC will take 3 columns for viewport width of m (1120px or larger), or 12 columns otherwise.
    colspan: { default: 12, m: 3 },
    // TOC will be pushed to the right by 9 columns for viewport width of m (1120px) or larger
    push: { m: 9 },
  },
  {
    // ReactMarkdown will take 9 columns for viewport width of m (1120px or larger), or 12 columns otherwise.
    colspan: { default: 12, m: 9 },
    // ReactMarkdown will be pulled to the left by 3 columns for viewport width of m (1120px) or larger.
    pull: { m: 3 },
  },
];
